module.exports = __webpack_public_path__ + "components/icon/static/sunset-d22c9690204f8ad5dabad9ac832d7656.svg";